import React, { Component } from 'react';

import { Loading, Alert, Button } from 'library';
import { UserValidator, ajax_wrapper, get_global_state } from 'functions';

class EntryDisplay extends Component {
    render() {
        let data = this.props.data;

        let content = null;
        if (this.props.type == 'folder') {
            return (
                <tr key={data.name} className="dropbox-entry">
                    <td
                        onClick={() => {
                            this.props.select_folder(data.name);
                        }}
                    >
                        <div className="white-border">
                            <i class="bi bi-folder-fill"></i>
                            <div style={{ marginLeft: '10px' }}>
                                {data.name}
                            </div>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return (
                <tr key={data.name} className="dropbox-entry">
                    <td onClick={(e) => this.props.toggle_file(data.name, e)}>
                        <div className="white-border">
                            <i class="bi bi-file-earmark-fill"></i>
                            <div style={{ marginLeft: '10px' }}>
                                {data.name}
                            </div>
                        </div>
                        <div className="checkbox">
                            {this.props.active ? (
                                <i class="white bi bi-check-square-fill"></i>
                            ) : (
                                <i class="white bi bi-square-fill"></i>
                            )}
                        </div>
                    </td>
                </tr>
            );
        }
    }
}

export default class DropboxExplorer extends Component {
    constructor(props) {
        super(props);

        let checker = new UserValidator();

        this.state = {
            loaded: true,
            dropbox_creds: checker.dropbox_creds(),

            dropbox_entries: [],

            selected_folder: [],
            selected_files: [],

            last_clicked_index: null,
        };
    }

    componentDidMount() {
        if (this.state.dropbox_creds) {
            this.search();
        }
    }

    search = () => {
        this.setState(
            {
                loaded: false,
            },
            function () {
                ajax_wrapper(
                    'GET',
                    '/api/dropbox_search/?folder=' +
                        encodeURIComponent(
                            this.state.selected_folder.join('/'),
                        ),
                    {},
                    this.load_search,
                );
            }.bind(this),
        );
    };

    load_search = (value) => {
        if ('error' in value) {
            this.setState({
                loaded: true,
                error: value['error'],
                dropbox_creds: null,
            });
        } else {
            this.setState({ loaded: true, dropbox_entries: value });
        }
    };

    start_dropbox_auth = () => {
        localStorage.setItem('redirect', this.props.redirect_url);
        ajax_wrapper(
            'POST',
            '/user/dropbox_auth/',
            {},
            this.redirect_to_dropbox,
        );
    };

    redirect_to_dropbox = (value) => {
        if ('error' in value) {
            this.setState({ error: value['error'] });
        } else {
            window.location.href = value['authorize_url'];
        }
    };

    go_back_folder = () => {
        let selected_folder = this.state.selected_folder.slice(
            0,
            this.state.selected_folder.length - 1,
        );
        this.setState(
            {
                selected_folder: selected_folder,
            },
            this.search,
        );
    };

    toggle_file = (file, event, index) => {
        let selected_files = [...this.state.selected_files];
        let last = this.state.last_clicked_index;

        // SHIFT RANGE SELECT
        if (event.shiftKey && last !== null) {
            let start = Math.min(last, index);
            let end = Math.max(last, index);

            let range = [];

            for (let i = start; i <= end; i++) {
                let entry = this.state.dropbox_entries[i];
                if (entry.type !== 'folder') {
                    range.push(entry.name);
                }
            }

            // decide whether selecting or deselecting
            let should_select = !selected_files.includes(file);

            for (let f of range) {
                if (should_select) {
                    if (!selected_files.includes(f)) {
                        selected_files.push(f);
                    }
                } else {
                    selected_files = selected_files.filter((x) => x !== f);
                }
            }
        } else {
            // normal toggle
            if (selected_files.includes(file)) {
                selected_files = selected_files.filter((x) => x !== file);
            } else {
                selected_files.push(file);
            }
        }

        this.setState(
            {
                selected_files,
                last_clicked_index: index,
            },
            this.update_form,
        );
    };

    assign_all = () => {
        let all_files = [];
        for (let item of this.state.dropbox_entries) {
            if (item.type !== 'folder') {
                all_files.push(item.name);
            }
        }

        this.setState({ selected_files: all_files }, this.update_form);
    };

    unassign_all = () => {
        this.setState({ selected_files: [] }, this.update_form);
    };

    update_form = () => {
        let new_state = {};
        new_state[this.props.files_name] = this.state.selected_files;
        new_state[this.props.folder_name] = this.state.selected_folder;
        this.props.set_form_state(new_state);
    };

    render() {
        let folders = [];
        let files = [];
        for (let [index, item] of this.state.dropbox_entries.entries()) {
            let item = this.state.dropbox_entries[index];
            if (item.type === 'folder') {
                folders.push(
                    <EntryDisplay
                        active={false}
                        type="folder"
                        data={item}
                        select_folder={(name) => {
                            this.setState(
                                {
                                    selected_folder: [
                                        ...this.state.selected_folder,
                                        name,
                                    ],
                                    selected_files: [],
                                },
                                function () {
                                    this.update_form();
                                    this.search();
                                },
                            );
                        }}
                    />,
                );
            } else {
                let active = '';
                if (this.state.selected_files.includes(item.name)) {
                    active = 'active';
                }

                files.push(
                    <EntryDisplay
                        key={item.name}
                        active={active}
                        type="file"
                        data={item}
                        toggle_file={(name, e) =>
                            this.toggle_file(name, e, index)
                        }
                    />,
                );
            }
        }

        let dropbox_error = null;
        if (this.state.error) {
            dropbox_error = <Alert type="danger">{this.state.error}</Alert>;
        }

        let dropbox_auth = null;
        if (!this.state.dropbox_creds || this.state.dropbox_creds === '') {
            dropbox_auth = (
                <Button type="primary" onClick={this.start_dropbox_auth}>
                    Sync With Dropbox
                </Button>
            );
        }

        let back_button = null;
        if (this.state.selected_folder.length > 0) {
            back_button = (
                <Button
                    style={{ marginLeft: '10px' }}
                    type="warning"
                    onClick={this.go_back_folder}
                >
                    Go Back
                </Button>
            );
        }

        return (
            <div style={{ position: 'relative' }}>
                <Loading loaded={this.state.loaded} cover={true}>
                    <div className="simple-card">
                        {dropbox_error}

                        {dropbox_auth}
                        <h2>Import From Dropbox</h2>
                        <h5>
                            Current Folder:{' '}
                            {this.state.selected_folder.length > 0
                                ? this.state.selected_folder.join('/')
                                : ' ~ '}
                        </h5>

                        {/*                        <p>
                            Click through your dropbox folders below until the
                            current folder above shows the folder with the songs
                            you want to import.
                        </p>*/}

                        <div
                            style={{
                                marginBottom: '10px',
                                float: 'right',
                            }}
                        >
                            <Button
                                onClick={this.assign_all}
                                type="primary"
                                style={{ marginLeft: '10px' }}
                            >
                                Assign All
                            </Button>
                            <Button
                                onClick={this.unassign_all}
                                type="danger"
                                style={{ marginLeft: '10px' }}
                            >
                                Unassign All
                            </Button>
                        </div>
                        {back_button}
                    </div>
                    <div className="simple-card">
                        <table className="dropbox-table">
                            <tr>
                                <th>Name</th>
                            </tr>
                            {folders}
                            {files}
                        </table>
                    </div>
                </Loading>
            </div>
        );
    }
}
